import { Outlet } from 'react-router-dom'
import OrderSelection from './order-selection/order-selection.component'
import OrderDetails from './order-details/order-details.component'
import MobileOrderSelection from './mobile-order-selection/mobile-order-selection.component'
import TwoColumnLayout from '../../layouts/two-column-layout/two-column-layout'

const OrderPage = () => {
  return (
    <>
      <TwoColumnLayout lockDetailsOverflow>
        <OrderSelection />
        <OrderDetails />
        <MobileOrderSelection />
      </TwoColumnLayout>
      <Outlet />
    </>
  )
}

export default OrderPage
